export default __webpack_public_path__ + "static/media/thaigo-screenshot-02.b967ee3a.png";